module.exports = __webpack_public_path__ + "img/group-sample.5f190f32.jpg";